<div class="info-container">
    <ng-container *ngIf="!isMobilePlatform">
        <mat-toolbar class="toolbar-form">
            <span>{{ 'organization_profile_info.toolbar_title' | translate }}</span>
            <span class="example-spacer"></span>
            <button mat-icon-button class="example-icon" (click)="closeDialog()">
                <mat-icon class="close-icon">close</mat-icon>
            </button>
        </mat-toolbar>
    </ng-container>
    <ng-container *ngIf="isMobilePlatform">
        <div class="toolbar-wrapper">
            <mat-toolbar class="toolbar-form">
                <button mat-icon-button class="example-icon" (click)="closeDialog()">
                    <mat-icon class="close-icon">chevron_left</mat-icon>
                </button>
                <span>{{ 'organization_profile_info.toolbar_title' | translate }}</span>
                <div class="more-container">
                    <button [disabled]="!(user.role === UserRoles.Root || user.role === UserRoles.Organisation)" mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu  #menu="matMenu">
                        <button mat-menu-item (click)="upload()">{{ 'organization_profile_info.change-image' | translate }}</button>
                        <mat-divider></mat-divider>
                        <button mat-menu-item  (click)="editProfile()">{{ 'organization_profile_info.edit-btn' | translate }}</button>
                        <mat-divider *ngIf="data && !hasEditProfile"></mat-divider>
                        <button *ngIf="data && !hasEditProfile" mat-menu-item (click)="deleteOrganisation('organisation-profile.buttons.delete_organisation')">{{ 'organisation-profile.buttons.delete_organisation' | translate }}</button>
                        <ng-container *ngIf="school.adminId !== user?.userId">
                            <mat-divider></mat-divider>
                            <button mat-menu-item *ngIf="!school.validated"
                                    class="raised-button"
                                    (click)="handleApprove(school.id, school.validated)">
                                {{ 'school-dashboard-table.button.approve' | translate }}
                            </button>
                            <button mat-menu-item *ngIf="school.validated"
                                    [disabled]="school.id === schoolId"
                                    [ngStyle]="{opacity: school.id === schoolId ? 0.3 : 1}"
                                    (click)="handleApprove(school.id, school.validated)">
                                {{ 'school-dashboard-table.button.disapprove' | translate }}
                            </button>
                        </ng-container>
                    </mat-menu>
                </div>
            </mat-toolbar>
            <mat-divider class="mobile-divider"></mat-divider>
        </div>
    </ng-container>
    <mat-divider class="mobile-divider"></mat-divider>
    <div class="info-card">
        <div class="image-wrapper">
            <div class="info-image-container"
                 [style]="getImageStyle(image)">
                <img src="" alt="">
                <div *ngIf="user.role === UserRoles.Root || user.role === UserRoles.Organisation" class="upload-btn" (click)="upload()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <g clip-path="url(#clip0_2294_107)">
                            <path
                                d="M4.25695 9.98472C4.44552 9.27761 4.71068 8.62354 5.05245 8.02249C5.39422 7.42145 5.81259 6.87345 6.30756 6.37847C7.88677 4.79927 9.77828 4.00377 11.9821 3.99199C14.1859 3.9802 16.0774 4.76391 17.6566 6.34312L17.7804 6.46686L17.7804 4.20412L19.7603 4.20412L19.7603 9.86097L14.1034 9.86097L14.1034 7.88107H16.3662L16.2424 7.75733C15.0639 6.57882 13.6467 5.99251 11.9909 5.9984C10.3351 6.00429 8.91207 6.60239 7.72178 7.79268C7.41536 8.0991 7.1502 8.43497 6.92628 8.80031C6.70237 9.16565 6.5197 9.56045 6.37827 9.98472L4.25695 9.98472ZM4.23928 19.7958L4.23928 14.139L9.89613 14.139L9.89613 16.1189L7.63339 16.1189L7.75713 16.2426C8.93564 17.4211 10.3528 18.0074 12.0086 18.0015C13.6644 17.9956 15.0875 17.3976 16.2778 16.2073C16.5842 15.9008 16.8493 15.565 17.0733 15.1996C17.2972 14.8343 17.4799 14.4395 17.6213 14.0152L19.7426 14.0152C19.554 14.7223 19.2889 15.3764 18.9471 15.9774C18.6053 16.5785 18.187 17.1265 17.692 17.6215C16.1128 19.2007 14.2213 19.9962 12.0175 20.008C9.81363 20.0197 7.92212 19.236 6.34292 17.6568L6.21918 17.5331L6.21918 19.7958H4.23928Z"
                                fill="#C97D70"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_2294_107">
                                <rect width="24" height="24" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </div>
            <div class="info-block right-side-block">
                <div class="item">
                    <div class="label">{{ 'organization_profile_info.labels.name' | translate }}</div>
                    <div class="value large">{{ school.name ? school.name : '—' }}</div>
                </div>
                <div class="item p-bottom-1">
                    <div class="label">{{ 'organization_profile_info.labels.location' | translate }}</div>
                    <div class="value font">{{ school.city ? school.city : '—' }}</div>
                </div>
                <mat-divider></mat-divider>
                <div class="item hybrid">
                    <div class="item-block">
                        <div class="label">{{ 'organization_profile_info.labels.member_of' | translate }}</div>
                        <ng-container *ngIf="school?.unions; else empty">
                            <div class="item union">
                                <ng-container *ngFor="let union of school?.unions; let last = last">
                                   <!--  <span matTooltip="{{union.membership}}" class="label-link">
                                      {{ union.name }}</span>-->
                                    <span>{{ union.name }}</span>
                                    <span class="label-link" *ngIf="!last"> | </span>
                                </ng-container>
                            </div>
                        </ng-container>
                        <ng-template #empty>
                            <div class="value">—</div>
                        </ng-template>
                    </div>
                </div>
                <mat-divider></mat-divider>
            </div>
        </div>

        <div class="info-card-content">
            <div class="info-block">
                <div class="item p-top-1">
                    <div class="label">{{ 'organization_profile_info.labels.goals' | translate }}</div>
                    <div class="value">{{ school.description ? school.description : '—' }}</div>
                </div>
                <!--   <mat-divider></mat-divider>
                <div class="item hybrid">
                    <div class="item-block">
                        <div class="label">{{ 'organization_profile_info.labels.instruments' | translate }}</div>
                        <div class="value">{{ school.instruments ? school.instruments.join(' | ') : '—' }}</div>
                    </div>
                </div>
                <mat-divider></mat-divider>
                 <div class="item hybrid">
                    <div class="item-block">
                        <div class="label">{{ 'organization_profile_info.labels.genres' | translate }}</div>
                        <div class="value">{{ school.genres ? school.genres.join(' | ') : '—' }}</div>
                    </div>
                </div>
                <mat-divider></mat-divider>  -->
                <div class="item hybrid">
                    <div class="item-block">
                        <div class="label">{{ 'organization_profile_info.labels.language' | translate }}</div>
                        <div class="value">{{ school.language ? getLanguage(school.language) : '—' }}</div>
                    </div>
                </div>
                <mat-divider></mat-divider>
                <div class="item hybrid">
                    <!--<div class="item-block">
                        <div class="label">{{ 'organization_profile_info.labels.price_range' | translate }}</div>
                        <div class="value">
                            {{ school.priceRange ? ('organization_profile_info.perLesson' | translate : school.priceRange) : '—' }}
                        </div>
                    </div>
                    <div class="item-block">
                        <div class="label">{{ 'organization_profile_info.teaching_location' | translate }}</div>
                        <div class="value">
                            {{ '—' }}
                        </div>
                    </div>
<                   <mat-divider vertical></mat-divider>-->
                    <div class="item-block">
                        <div class="label">{{ 'organization_profile_info.teachers' | translate }}</div>
                        <div class="value">{{ school.teachersAmount }}</div>
                    </div>
                    <mat-divider vertical></mat-divider>
                    <div class="item-block">
                        <div class="label">{{ 'organization_profile_info.labels.sponsor' | translate }}</div>
                        <div class="value">{{ school.sponsor ? school.sponsor : '—' }}</div>
                    </div>
                </div>
                <mat-divider></mat-divider>
                <ng-container *ngIf="school?.socials && school.socials.length > 0">
                    <div class="item socials">
                        <ng-container *ngFor="let social of school?.socials; let last = last">
                            <a href="{{social.link}}" target="_blank" class="label-link">{{ social.type }}</a>
                            <span class="label-link" *ngIf="!last"> | </span>
                        </ng-container>
                    </div>
                    <mat-divider></mat-divider>
                </ng-container>
                <div *ngIf="user.role === UserRoles.Root || user.role === UserRoles.Organisation" class="btn-container custom-theme">
                        <button mat-stroked-button color="primary" (click)="upload()">{{ 'organization_profile_info.change-image' | translate }}</button>
                        <button mat-stroked-button color="primary" (click)="editProfile()">{{ 'organization_profile_info.edit-btn' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

